import { Component, Input } from '@angular/core';
import { ThemeService } from '../../service/theme.service';

@Component({
  selector: 'app-invoice-device-count-info',
  templateUrl: './device-count-info.component.html',
  styleUrls: ['./device-count-info.component.css'],
  standalone: false,
})
export class DeviceCountInfoComponent {
  // Count displayed next to the label.
  @Input() deviceCount = 0;
  // Device rows shown inside the info modal.
  @Input() devices: Array<{
    thingName: string;
    address: string;
    usageLabel: string;
  }> = [];

  // Modal visibility state.
  showDeviceInfoModal = false;

  constructor(public theme: ThemeService) {}

  openDeviceInfo(): void {
    // Show the selected devices modal.
    this.showDeviceInfoModal = true;
  }

  closeDeviceInfo(): void {
    // Hide the selected devices modal.
    this.showDeviceInfoModal = false;
  }
}
